import { render, staticRenderFns } from "./ProcessosFalhaCardSuporte.vue?vue&type=template&id=73f37c45"
import script from "./ProcessosFalhaCardSuporte.vue?vue&type=script&lang=ts"
export * from "./ProcessosFalhaCardSuporte.vue?vue&type=script&lang=ts"
import style0 from "./ProcessosFalhaCardSuporte.vue?vue&type=style&index=0&id=73f37c45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports